export default "__VITE_ASSET__89094bf0__"